//https://developers.facebook.com/docs/instagram-basic-display-api/reference/oauth-authorize
// ! nunca usado
//  export const INSTAGRAM_URL = "https://photonowmobile.trulogic.com.br/";
export const INSTAGRAM_ID = 415425804330277;
// ! nunca usado
//export const INSTAGRAM_REDIRECT = "/auth-instagram/";
//export const INSTAGRAM_SCOPE = "user_profile, user_media";
//let pass = 139474598504852;
//export { pass };
